export default "__VITE_PUBLIC_ASSET__39b1efef__"